import { createSlice } from '@reduxjs/toolkit'
import { defaultTo } from 'ramda'
import { dataAnalyticsSignalId } from '../Utils/DataAnalytics'

const slice = createSlice({
  name: 'dataAnalyticsEventSignalValues',
  initialState: {},
  reducers: {
    setSignalValues: (state, { payload }) => {
      state[`${payload.eventId}`] = {
        ...defaultTo({}, state[`${payload.eventId}`]),
        [dataAnalyticsSignalId(payload)]: {
          data: payload.data,
          vTable: payload.vTable,
        }
      }
    },
  },
})

export const { setSignalValues } = slice.actions

export default slice.reducer

export const selectSignalValues = (eventId, signalId) => (state) =>
  defaultTo([], state.dataAnalyticsEventSignalValues?.[eventId]?.[signalId]).data
export const selectSignalVTable = (eventId, signalId) => (state) =>
  defaultTo({}, state.dataAnalyticsEventSignalValues?.[eventId]?.[signalId]?.vTable)
